import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import PinterestIcon from "@mui/icons-material/Pinterest";
import TwitterIcon from "@mui/icons-material/Twitter";
import React from "react";
import "../Style/Footer.scss";

const Footer = () => {
  return (
   
    <footer >
      <div className="waves">
        <div className="wave" id="wave1"></div>
        <div className="wave" id="wave2"></div>
        <div className="wave" id="wave3"></div>
        <div className="wave" id="wave4"></div>
     </div>
      <ul className="social_icon">
        <li><a href="#"><FacebookIcon/></a></li>
        <li><a href="#"><InstagramIcon/></a></li>
        <li><a href="#"><LinkedInIcon/></a></li>
        <li><a href="#"><TwitterIcon/></a></li>
        <li><a href="#"><PinterestIcon/></a></li>
      </ul>
           <ul className="menu">
                <li> <a href="#home">Home </a> </li>
                <li><a href="#About">  About </a>  </li>
                 <li> <a href="#our projects">  Our Projects </a> </li>
                 <li><a href="#service">  Service  </a>  </li>
                 <li><a href="#contact us">Contact Us</a></li> 
          </ul>
          <p>Creativity with us and Inspiration Copyright © 2022 3w solutions</p>
     
    </footer>
                  
  );
};

export default Footer;
